import { useCallback } from 'react'
import { useSetRecoilState } from 'recoil'
import { useNavigate } from 'react-router'
import { loggedUserState } from '../states/logged-user-state'

export const useLogout = () => {
  const setUser = useSetRecoilState(loggedUserState)
  const navigate = useNavigate()

  return useCallback(() => {
    window.localStorage.removeItem('token')
    setUser(null)
    navigate('/', { replace: true })
  }, [])
}